import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import store from "./store/store";
import App from "./App";
import { LoadingBarContainer } from "react-top-loading-bar";

const root = createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <LoadingBarContainer>
      <App />
    </LoadingBarContainer>
  </Provider>
);
